import { getStylePackById } from '@/themes/stylePacks';

/**
 * Решение владельца №4 (2026-10-08, повтор эталона Slimkit;
 * spec shared/screen-container.md «Что добавить» п.2): пауза между выбором
 * варианта и авто-переходом. У эталона выбранная карточка «мигает» градиентом
 * 200 мс и только потом сменяется экран; у нас переход срабатывал в том же
 * эффекте, и выбранный вид не успевал показаться.
 *
 * Источник — стиль-пак (`states.advanceDelayMs`). Отсутствие пака, поля,
 * ноль и мусор → 0, то есть переход сразу, ровно как было.
 */
export const MAX_ADVANCE_DELAY_MS = 2000;

export function normalizeAdvanceDelayMs(value: unknown): number {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0)
    return 0;
  return Math.min(Math.round(value), MAX_ADVANCE_DELAY_MS);
}

export function resolveAdvanceDelayMs(stylePackId: string | undefined): number {
  if (!stylePackId) return 0;
  return normalizeAdvanceDelayMs(
    getStylePackById(stylePackId)?.states.advanceDelayMs,
  );
}
